import React, { useState } from "react";
// import Banner from "../../components/common/banner";
import AdminHeader from "../../components/common/admin-header";
import { Col, Container, Row, Form, Button, Toast } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { postData } from "../../api";
import { useNavigate } from "react-router-dom";

function AdminCareerCreate() {
  const navigation = useNavigate();
  const [show, setShow] = useState(false);
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState(null);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  console.log("errors", errors);


  const handleReset = () => {
    reset(); 
    window.scrollTo({ top: 0, behavior: 'smooth' }); 
  };

  const handleContactSubmit = async (data) => {
    try {
      console.log("data", data);
      const url = `${process.env.REACT_APP_BASEURL}/admin/career/create`;

      const result = await postData(url, data);
      console.log('result ----------', result);
      if (result.status) {
        setMessage("Opening add successfully");
        setShow(true);
        setTimeout(() => {
          navigation("/admin-career");
        }, 2000);
      } else {
        throw new Error(result);
      }
    } catch (err) {
      console.log("err", err);
      setMessage("Opening add failed");
      setAlert(true);

      setTimeout(() => {
        navigation("/admin-career");
      }, 2000);
    }
  };

  return (
    <>
      {/* <Banner title="Admin Career" /> */}
      <Container>
        <AdminHeader />
        <Row>
          <Col md={12} className="text-end">
            <div className="export text-end mb-3">
              <Button
                variant="primary"
                className="m-5"
                onClick={() => navigation("/admin-career")}
              >
                Back
              </Button>
            </div>
          </Col>
        </Row>
        <Row className="m-3 ">
          <Col lg={6} md={6} sm={12} className="offset-lg-3">
            <div className="quote_wrapper">
            <div  className='mb-5' style={{background:'#16c1f7', padding:'5px'}}>
              <h1 className="m-2" style={{color:'#fff'}}> Opening Create</h1>
              </div>
              <Form onSubmit={handleSubmit(handleContactSubmit)} noValidate>
                <Row>
                  <Col lg={12}>
                    <div className="form_box mb-30">
                      <Form.Control
                        required
                        type="text"
                        name="title"
                        placeholder="Title"
                        style={{border:'1px solid #118ce9'}}
                        {...register("title", { required: true })}
                      />
                      {errors.title && errors.title.type === "required" && (
                        <span className="text-danger">title is required</span>
                      )}
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="form_box mb-30">
                      <Form.Control
                        required
                        type="text"
                        name="location"
                        style={{border:'1px solid #118ce9'}}
                        placeholder="Location"
                        {...register("location", { required: true })}
                      />
                      {errors.location &&
                        errors.location.type === "required" && (
                          <span className="text-danger">
                            location is required
                          </span>
                        )}
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="form_box mb-30">
                      <Form.Control
                        required
                        type="text"
                        name="position"
                        style={{border:'1px solid #118ce9'}}
                        placeholder="Position"
                        {...register("position", { required: true })}
                      />
                      {errors.position &&
                        errors.position.type === "required" && (
                          <span className="text-danger">
                            position is required
                          </span>
                        )}
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="form_box mb-30">
                      <Form.Control
                        required
                        type="text"
                        name="eduction"
                        style={{border:'1px solid #118ce9'}}
                        placeholder="Eduction"
                        {...register("eduction", { required: true })}
                      />
                      {errors.eduction &&
                        errors.eduction.type === "required" && (
                          <span className="text-danger">
                            eduction is required
                          </span>
                        )}
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="form_box mb-30">
                      <Form.Control
                        required
                        type="text"
                        name="skill"
                        style={{border:'1px solid #118ce9'}}
                        placeholder="skill"
                        {...register("skill", { required: true })}
                      />
                      {errors.skill && errors.skill.type === "required" && (
                        <span className="text-danger">skill is required</span>
                      )}
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="form_box mb-30">
                      <Form.Control
                        required
                        type="text"
                        name="experience"
                        style={{border:'1px solid #118ce9'}}
                        placeholder="Experience"
                        {...register("experience", { required: true })}
                      />
                      {errors.experience &&
                        errors.experience.type === "required" && (
                          <span className="text-danger">
                            experience is required
                          </span>
                        )}
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="form_box mb-30">
                      <Form.Control
                        required
                        as="textarea"
                        name="responsibilities"
                        style={{border:'1px solid #118ce9'}}
                        placeholder="Responsibilities"
                        {...register("responsibilities", { required: true })}
                      />
                      {errors.responsibilities &&
                        errors.responsibilities.type === "required" && (
                          <span className="text-danger">
                            responsibilities is required
                          </span>
                        )}
                    </div>
                  </Col>

                    <Col lg={6}>
                      <label>Open Date</label>
                      <div className="form_box mb-30">
                        <Form.Control
                          required
                          type="date"
                          name="openDate"
                          style={{border:'1px solid #118ce9'}}
                          placeholder="openDate"
                          {...register("openDate", { required: true })}
                        />
                        {errors.openDate &&
                          errors.openDate.type === "required" && (
                            <span className="text-danger">
                              Open Date is required
                            </span>
                          )}
                      </div>
                    </Col>

                    <Col lg={6}>
                      <label>Expiry Date</label>
                      <div className="form_box mb-30">
                        <Form.Control
                          required
                          type="date"
                          name="expiryDate"
                          style={{border:'1px solid #118ce9'}}
                          placeholder="expiryDate"
                          {...register("expiryDate", { required: true })}
                        />
                        {errors.expiryDate &&
                          errors.expiryDate.type === "required" && (
                            <span className="text-danger">
                              Expiry Date is required
                            </span>
                          )}
                      </div>
                    </Col>

                  <Col lg={12} className="mt-2">
                    <div className="text_center mt-2">
                      <Button type="submit" className="btn btn-primary">
                        Submit
                      </Button>
                      <Button
                        variant="secondary"
                        className="m-1"
                      onClick={() => handleReset ()}
                      >
                        Reset
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          </Col>
        </Row>
        <Toast
          onClose={() => setShow(false)}
          show={show}
          delay={3000}
          autohide
          className="toast"
          bg="success"
        >
          <Toast.Body>Job create successfully</Toast.Body>
        </Toast>
        <Toast
          onClose={() => setAlert(false)}
          show={alert}
          delay={3000}
          autohide
          className="toast"
          bg="danger"
        >
          <Toast.Body>{message && message}</Toast.Body>
        </Toast>
      </Container>
    </>
  );
}

export default AdminCareerCreate;
